import prd from './configureStore.prod';
import dev from './configureStore.dev';

const actualEnv = process.env.NODE_ENV === 'production'  ? prd : dev; // eslint-disable-line no-undef

export default actualEnv;
